const content = new Map();

const matrix = {
  scenes: [
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 1,
      // videoPath: 'assets/videos/3-0_MEETING MADNESS.mp4',
      // videoPoster: 'assets/videos/3-0_MEETING MADNESS.jpg'
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/1-0_TECH+STRETCH+OR+RESET.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 1.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/1-1_GET+STUCK+INTO+EMAILS2.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 1.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/1-2_A+QUICK+WORKOUT2.mp4",
      correct: true,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 1.3,
      //videoPath: 'assets/videos/a.mp4',
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/1-3_TAKE+A+BREATH2.mp4",
      correct: true,
    },
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 2,
      //videoPath: 'assets/videos/a.mp4',

      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-0_WHAT+TO+WEAR2.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 2.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-1_SOCKS.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 2.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-2_LOUD+SHIRT.mp4",

      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 2.3,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-3_FANCY+DRESS.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 2.4,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-4_KIMONO.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 2.5,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/2-5_FLEXIBLE+OUTFIT.mp4",
      correct: true,
    },
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 3,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/3-0_MEETING+MADNESS2.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 3.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/3-1_THE+WORST+COMMUTE+IMAGINABLE2.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 3.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/3-2_HOME+OFFICE2.mp4",
      correct: true,
    },
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 4,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/4-0_MALWARE+MOMENT2.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 4.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/4-1_VIRUS.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 4.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/4-2_VILLAIN+UNCOVERED.mp4",
      correct: true,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 4.3,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/4-3_LAPTOP+SLAM.mp4",
      correct: false,
    },
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 5,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/5-0_FLEXIBLE+FUN2.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 5.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/5-1_OVERWORKING2.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 5.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/5-2_CULINARY+SKILLS2.mp4",
      correct: true,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 5.3,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/5-3_VIRTUADECK2.mp4",
      correct: true,
    },
    {
      type: "MAIN_VIDEO_SCENE",
      scene: 6,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/6-0_ACTIVE+ANYWHERE2.mp4",
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 6.1,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/6-1_HEAD+BACK+HOME2.mp4",
      correct: false,
    },
    {
      type: "SUB_VIDEO_SCENE",
      scene: 6.2,
      videoPath:
        "https://kaspersky-axicom.s3.eu-west-2.amazonaws.com/videos/6-2_A+NEW+SETTING2.mp4",
      correct: true,
    },
  ],
};

// Update content map
for (const key in matrix) {
  if (!matrix.hasOwnProperty(key)) continue;
  content.set(key, matrix[key]);
}

function isBoolean(n) {
  return !!n === n;
}

export default content;
